import type { CSSProperties, ReactNode } from 'react';

export interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
  /** Associates a footer submit button with a form elsewhere in the dialog. */
  form?: string;
  onClick?: () => void;
  /** For a symbol-only button (↑ ↓ ×): the accessible name. */
  'aria-label'?: string;
  style?: CSSProperties;
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  type = 'button',
  form,
  onClick,
  style,
  ...rest
}: ButtonProps) {
  const classes = ['fs-button', `fs-button--${variant}`];
  if (size !== 'md') classes.push(`fs-button--${size}`);
  if (fullWidth) classes.push('fs-button--full');
  return (
    <button
      className={classes.join(' ')}
      type={type}
      form={form}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      aria-label={rest['aria-label']}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
}
